class Document {
  _id
  _ref

  constructor (ref) {
    this._id = ref.id
    this._ref = ref
  }

  toJSON () {
    const data = this.toObject()
    return JSON.stringify(data, null, 2)
  }

  toObject () {
    const data = Object.assign({}, this)
    delete data._id
    delete data._ref
    return data
  }
}

export { Document }
